import { render, staticRenderFns } from "./question-type-switcher.vue?vue&type=template&id=3d064f3d&"
import script from "./question-type-switcher.vue?vue&type=script&lang=js&"
export * from "./question-type-switcher.vue?vue&type=script&lang=js&"
import style0 from "./question-type-switcher.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports